import { Platfrom } from '../../utils/PlatformConstants';
// 公共能力
/**
 * 端内打开网页 /web A&I
 * 拍照扫描 /scan A
 * 拍照扫描(指定Tab) /scan/pattern A
 * 投影文档 /tv_projection A&I
 * 文档瘦身 /doc_down_sizing A&I
 * 首页 /root A&I
 * 桌面小组件 /app_widget A&I
 * 文件雷达 /radar A
 * 聊天文档 /generalfile A
 * 微信小程序 /mini_program A&I
 * 端内小程序 /handle_req/utils/open_miniprogram A&I
 * 我的钱包 /my_pursing A
 * 找回文档 /recoveryFile A&I
 * 扫码打印 /v2/scan/print A
 * 反馈服务中心 /service_center A
 * 会议 /share_play A&I
 * 皮肤商城 /theme_store A
 * 打印小程序 /print_widget A
 * 缓存文档 /cacheDocument A
 * 消息中心 /msgcenter A
 * 公告详情界面 /wps_notice A
 * 文件历史记录 /wps_history_version A
 * 会议sdk /share_play_sdk
 */

// PDF处理能力
/**
 * Pdf转Doc /pdf_to_doc A&I
 * Pdf转Excel /pdf_to_et I
 * Pdf转Ppt /pdf_to_ppt A&I
 * Pdf标注 /pdf_annotation A
 * Pdf编辑 /pdf_edit A
 * Pdf导出批注 /pdf_exportkeynote A
 * Pdf提取表格 /pdf_extract_sheet A&I
 * Pdf提取文字 /pdf_extract_text A
 * Pdf页面管理 /pdf_pageadjust A
 * Pdf签名 /pdf_sign A
 * Pdf水印 /pdf_watermark_delete A
 * 输出为Pdf文档 /export_pdf A
 * 输出为纯图Pdf /export_pic_file A
 */

// 表格处理能力
/**
 * 输出卡片图片 /AK20210203RFQSNK A
 * 合并工作表  /sheet_merge A
 * WPS表单 /et_formtool A
 * 输出纯数值表格 /formular2num A
 */

// 图片处理能力
/**
 * 图片转表格 /ocr_et A&I
 * 图片转Pdf /ocr_pdf A&I
 * 图片转Ppt /pic2PPT A
 * 图片提取文字  /ocr_text A
 * 图片拼接 /imageSplicing A
 * 图片翻译 /ocrTranslation A
 * 文档输出为长图片 /share_long_pic A
 */

// 演示能力
/**
 * 录制幻灯片 /play_record A
 */

// 通用文档能力
/**
 * 长语音输入 /audio_input_recognizer A
 * 语音速记 /audio_shorthand A
 * 提取页面 /file_extract A
 * 合并文档 /file_merge A
 * 批量提取图片 /extract_pics A
 * 全文翻译 /translate A
 * 音频转文字 /audio_to_doc A
 * 文档认证 /file_evidence A
 * 逐页输出图片 /export_pages A&I
 */

// 云能力
/**
 * 文件备份 /cloudbackup  A&I
 * 跨端传图 /multi_port_upload A
 * 文档云同步 /wps_open_space_manager A
 * 共享文件夹列表 /wps_share_file A&I
 * 文件传输 /transfer2pc A
 * 上传文件 /wps_drive_upload A
 * 云文档文件夹 /wps_cloud_open_file A
 * 云文档目录 /wps_drive A
 * 跨端传输 /softbus A&I
 * 备份设置 /radar_setting A
 * 传输助手 /transfer_helper A
 * 常用的应用文件夹目录打开 /oftenuse A
 * WPS云设置页 /wps_cloud_settings A
 * 管理云空间 /wps_cloud_space_manager A
 */

// 稻壳
/**
 * 稻壳离线模板 /docer_buy A
 * 稻壳商城 /docer_template A&I
 * 稻壳搜索 /searchdocer A
 * 综合搜索 /searchFiles A
 * 论文查重 /paper_check A&I
 * 论文排版 /paper_composition A
 * 稻壳模板设计师页面 /template_author A
 * 稻壳自定义模板 /template_diy A
 * 稻壳模板预览页 /docer A
 * 图片商城图片预览页 /docer_pic A
 * 稻壳素材搜索 /material_search A
 * 简历助手 /resumehelper A
 * 超级ppt /superppt A
 * 证件照 /id_photo I
 */
export const AbilityConstants = [
  // 公共能力
  {
    key: '/web',
    platform: [Platfrom.ANDROID, Platfrom.IOS],
  },
  {
    key: '/scan',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/scan/pattern',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/tv_projection',
    platform: [Platfrom.ANDROID, Platfrom.IOS],
  },
  {
    key: '/doc_down_sizing',
    platform: [Platfrom.ANDROID, Platfrom.IOS],
  },
  {
    key: '/root',
    platform: [Platfrom.ANDROID, Platfrom.IOS],
  },
  {
    key: '/app_widget',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/radar',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/generalfile',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/mini_program',
    platform: [Platfrom.ANDROID, Platfrom.IOS],
  },
  {
    key: '/handle_req/utils/open_miniprogram',
    platform: [Platfrom.ANDROID, Platfrom.IOS],
  },
  {
    key: '/my_pursing',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/recoveryFile',
    platform: [Platfrom.ANDROID, Platfrom.IOS],
  },
  {
    key: '/v2/scan/print',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/service_center',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/share_play',
    platform: [Platfrom.ANDROID, Platfrom.IOS],
  },
  {
    key: '/theme_store',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/print_widget',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/cacheDocument',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/msgcenter',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/wps_notice',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/wps_history_version',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/share_play_sdk',
    platform: [Platfrom.ANDROID],
  },

  // pdf能力
  {
    key: '/pdf_to_doc',
    platform: [Platfrom.ANDROID, Platfrom.IOS],
  },
  {
    key: '/pdf_to_et',
    platform: [Platfrom.IOS],
  },
  {
    key: '/pdf_to_ppt',
    platform: [Platfrom.ANDROID, Platfrom.IOS],
  },
  {
    key: '/pdf_annotation',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/pdf_edit',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/pdf_exportkeynote',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/pdf_extract_sheet',
    platform: [Platfrom.ANDROID, Platfrom.IOS],
  },
  {
    key: '/pdf_extract_text',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/pdf_pageadjust',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/pdf_sign',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/pdf_watermark_delete',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/export_pdf',
    platform: [Platfrom.ANDROID],
    viewKey: '1000',
  },
  {
    key: '/export_pic_file',
    platform: [Platfrom.ANDROID],
  },

  // 图片处理能力
  {
    key: '/ocr_et',
    platform: [Platfrom.ANDROID, Platfrom.IOS],
  },
  {
    key: '/ocr_pdf',
    platform: [Platfrom.ANDROID, Platfrom.IOS],
  },
  {
    key: '/pic2PPT',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/ocr_text',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/imageSplicing',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/ocrTranslation',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/share_long_pic',
    platform: [Platfrom.ANDROID],
  },

  // 表格文件处理能力
  {
    key: '/AK20210203RFQSNK',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/sheet_merge',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/et_formtool',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/formular2num',
    platform: [Platfrom.ANDROID],
  },

  // 演示能力
  {
    key: '/play_record',
    platform: [Platfrom.ANDROID],
  },

  // 通用文档能力
  {
    key: '/audio_input_recognizer',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/audio_shorthand',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/file_extract',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/file_merge',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/extract_pics',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/translate',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/audio_to_doc',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/file_evidence',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/export_pages',
    platform: [Platfrom.ANDROID, Platfrom.IOS],
  },

  // 云能力
  {
    key: '/cloudbackup',
    platform: [Platfrom.ANDROID, Platfrom.IOS],
  },
  {
    key: '/multi_port_upload',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/wps_open_space_manager',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/wps_share_file',
    platform: [Platfrom.ANDROID, Platfrom.IOS],
  },
  {
    key: '/transfer2pc',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/wps_drive_upload',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/wps_cloud_open_file',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/wps_drive',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/softbus',
    platform: [Platfrom.ANDROID, Platfrom.IOS],
    viewKey: '3000',
  },
  {
    key: '/radar_setting',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/transfer_helper',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/oftenuse',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/wps_cloud_settings',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/wps_cloud_space_manager',
    platform: [Platfrom.ANDROID],
  },

  // 稻壳模板
  {
    key: '/docer_buy',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/docer_template',
    platform: [Platfrom.ANDROID, Platfrom.IOS],
  },
  {
    key: '/searchdocer',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/searchFiles',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/paper_check',
    platform: [Platfrom.ANDROID, Platfrom.IOS],
  },
  {
    key: '/paper_composition',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/template_author',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/template_diy',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/docer',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/docer_pic',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/material_search',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/resumehelper',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/superppt',
    platform: [Platfrom.ANDROID],
  },
  {
    key: '/id_photo',
    platform: [Platfrom.ANDROID, Platfrom.IOS],
  },
  {
    key: '/face_look_doc',
    platform: [Platfrom.ANDROID, Platfrom.IOS],
  },
];
